/* Pirate kiwi variant — eyepatch + hat. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderPirate(p: KiwiPalette) {
  return (
    <>
      {/* Pirate hat */}
      <path d="M8 2H24V4H26V6H6V4H8V2Z" fill={p.accent} opacity={0.5} />
      <rect x="14" y="0" width="4" height="2" fill={p.accent} opacity={0.4} />
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />
      {/* Highlight */}
      <rect x="20" y="10" width="2" height="2" fill={p.highlight} opacity={0.3} />
      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />
      {/* Eyepatch */}
      <rect x="10" y="10" width="6" height="6" fill={p.pupil} opacity={0.6} />
      {/* Eyepatch strap */}
      <rect x="16" y="12" width="10" height="2" fill={p.pupil} opacity={0.35} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
